// extracted by mini-css-extract-plugin
module.exports = {"block":"e_3u","lead":"e_4u","faces":"e_5u","face":"e_6u","plus":"e_7u","copy":"e_8u","title":"e_9u","text":"e_-u","button":"e_av","buttonIcon":"e_bv"};